import { isEmptyObject, isPresent } from '@fcom/core/index';
import { ServiceSelections, ServiceCatalogSelections, TravelerService } from '@fcom/dapi/interfaces';

import { FrequentFlyerTierLevel } from '../interfaces/utils.interface';

export const getCMSTier = (tier: string): string => {
  switch (tier) {
    case FrequentFlyerTierLevel.JUNIOR.toString():
      return 'JUNIOR';
    case FrequentFlyerTierLevel.PLUS.toString():
      return 'BASIC';
    case FrequentFlyerTierLevel.SILVER.toString():
      return 'SILVER';
    case FrequentFlyerTierLevel.GOLD.toString():
      return 'GOLD';
    case FrequentFlyerTierLevel.PLATINUM.toString():
      return 'PLATINUM';
    case FrequentFlyerTierLevel.LUMO.toString():
      return 'PLATINUM LUMO';
    default:
      return '';
  }
};

export const removeEmptySelections = (selections: ServiceSelections): Partial<ServiceSelections> =>
  Object.entries(selections).reduce<Partial<ServiceSelections>>((overlapping, [cat, categorySelections]) => {
    if (!isEmptyObject(categorySelections)) {
      overlapping[cat as keyof ServiceSelections] = categorySelections;
    }
    return overlapping;
  }, {});

/**
 * Flattens category-keyed {@link ServiceSelections} into a single {@link ServiceCatalogSelections},
 * and records the top-level category of each service in the `parentCategory` property.
 *
 */
export const formatSelectionsByFragmentAndTraveler = (
  selections: Partial<ServiceSelections>
): ServiceCatalogSelections<TravelerService[]> =>
  Object.entries(selections).reduce<ServiceCatalogSelections<TravelerService[]>>(
    (result, [category, catalogSelections]) => {
      Object.entries(catalogSelections ?? {}).forEach(([fragmentId, selectionsPerTraveler]) => {
        Object.entries(selectionsPerTraveler).forEach(([travelerId, service]) => {
          const services = (Array.isArray(service) ? service : [service])
            .filter(isPresent)
            .map((travelerService) => ({ ...travelerService, parentCategory: category }));
          result[fragmentId] ??= {};
          result[fragmentId][travelerId] = [...(result[fragmentId][travelerId] ?? []), ...services];
        });
      });
      return result;
    },
    {}
  );
